// US-standard currency formatting helpers.
// Thousands separator: comma. Decimal: dot. Always 2 decimal places.

const USD_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const NUMBER_FORMATTER = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Format a number as "$1,234" (no decimals). Useful for compact card displays. */
export function formatUSDCompact(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "$0";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
}

/** Format a number as "$1,234.56". Falsy/invalid → "$0.00". */
export function formatUSD(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "$0.00";
  return USD_FORMATTER.format(n);
}

/** Format a number as "1,234.56" (no currency symbol). */
export function formatNumber(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0.00";
  return NUMBER_FORMATTER.format(n);
}

/**
 * Parse a user-entered currency-ish string into a plain Number.
 * Accepts: "1,234.56", "$1,234.56", "1234.56", "1234", " 1, 234 . 56 ".
 * Strips: $, commas, whitespace, letters. Returns 0 for empty/invalid.
 */
export function parseUSD(input) {
  if (input === null || input === undefined) return 0;
  if (typeof input === "number") return Number.isFinite(input) ? input : 0;
  const cleaned = String(input)
    .replace(/[^0-9.\-]/g, "") // keep digits, dot, minus
    .replace(/(?!^)-/g, ""); // only leading minus
  if (cleaned === "" || cleaned === "-" || cleaned === ".") return 0;
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
}
